// client/src/components/comunicacao/manual/ComunicacaoManualRow.js
import React from 'react';
import { MoreVertical, Mail, MessageCircle, Smartphone, Calendar } from 'lucide-react';
import PropTypes from 'prop-types';
import { useMutateComunicacaoConfig } from '../../../hooks/useComunicacaoConfig';

// ✅ Sem editar — registros de tipo Manual são legados (ver
// ComunicacaoManualPage.js), só podem ser excluídos. O toggle de
// ativo/inativo abaixo é só um registro de estado (persiste no banco) — o
// envio manual de verdade não passa mais por ComunicacaoConfig nenhuma (o
// template é escolhido na hora do envio, direto na tela do agendamento),
// então desativar aqui não muda nenhum envio em andamento.
const ComunicacaoManualRow = ({ config, onOpenActions, isDeleting }) => {
    const { updateConfig } = useMutateComunicacaoConfig();
    const ativo = config.ativo !== false;

    const getCanalIcon = (canal) => {
        switch (canal) {
            case 'WhatsApp': return <MessageCircle size={16} className="text-green-600" />;
            case 'Email': return <Mail size={16} className="text-blue-600" />;
            case 'SMS': return <Smartphone size={16} className="text-purple-600" />;
            default: return <MessageCircle size={16} />;
        }
    };

    const getEventoLabel = (evento) => {
        const eventos = {
            'Agendado': 'Agendado',
            'Confirmado': 'Confirmado',
            'Pendente': 'Pendente',
            'Concluido': 'Concluído',
            'Cancelado': 'Cancelado'
        };
        return eventos[evento] || evento;
    };

    return (
        <tr className="hover:bg-gray-50">
            <td className="py-3">
                <div className="flex items-center">
                    <div className="ml-3">
                        <p className="text-sm font-medium text-gray-900">
                            {config.nome || 'Configuração sem nome'}
                        </p>
                        <p className="text-sm text-gray-500">
                            Tipo: {config.tipo}
                        </p>
                    </div>
                </div>
            </td>
            
            {/* AGORA MOSTRA O EVENTO */}
            <td className="py-3">
                <div className="flex items-center">
                    <Calendar size={16} className="text-gray-600 mr-2" />
                    <span className="text-sm text-gray-900">{getEventoLabel(config.evento)}</span>
                </div>
            </td>
            
            <td className="py-3">
                <div className="flex items-center">
                    {getCanalIcon(config.canal)}
                    <span className="ml-2 text-sm text-gray-900">{config.canal}</span>
                </div>
            </td>
            
            <td className="py-3">
                <label className="toggle-switch" title={ativo ? 'Desativar' : 'Ativar'}>
                    <input
                        type="checkbox"
                        checked={ativo}
                        disabled={updateConfig.isPending}
                        onChange={(e) => updateConfig.mutate({ id: config._id, data: { ativo: e.target.checked } })}
                    />
                    <span className="toggle-slider" />
                </label>
            </td>

            <td className="text-right">
                <button
                    onClick={() => onOpenActions(config)}
                    disabled={isDeleting}
                    title="Ações"
                    className="action-button-icon text-gray-600 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    <MoreVertical size={18} />
                </button>
            </td>
        </tr>
    );
};

// ✅ Adicionado PropTypes
ComunicacaoManualRow.propTypes = {
    config: PropTypes.shape({
        _id: PropTypes.string,
        nome: PropTypes.string,
        tipo: PropTypes.string,
        evento: PropTypes.string,
        canal: PropTypes.string,
        template: PropTypes.shape({
            nome: PropTypes.string,
        }),
        createdAt: PropTypes.string,
        ativo: PropTypes.bool,
    }).isRequired,
    onOpenActions: PropTypes.func.isRequired,
    isDeleting: PropTypes.bool,
};

ComunicacaoManualRow.defaultProps = {
    isDeleting: false,
};

export default ComunicacaoManualRow;